import TableFilter from './tableFilter'
import { useDispatch } from 'react-redux'
import { useState } from 'react'
import ExportButton from '../../common/ExportButton'
import { appAllGetBoliBooking } from '../../store/boliBooking'
import { boliBookingExportColumns } from '../../config/exportColumns/boliBookingExportColumns'

function BoliBooking() {
	const dispatch = useDispatch()

	const hubId = localStorage.getItem('hubId')
	const permissionOfHub = localStorage.getItem('permissionOfHub')

	const [exportFilters, setExportFilters] = useState({})

	return (
		<>
			<div className="content-wrapper">
				<div className="content-heading d-flex justify-content-between">
					<div>Boli Booking</div>

					<ExportButton
						fetchAction={params =>
							dispatch(
								appAllGetBoliBooking({
									...params,
									...exportFilters,
									hub: hubId || permissionOfHub,
									page: 1,
									limit: 10000,
									loading: false,
								}),
							)
						}
						columns={boliBookingExportColumns}
						fileName="Boli_Booking"
						sheetName="Boli Booking"
						buttonText="Export Boli"
					/>
				</div>

				<TableFilter setExportFilters={setExportFilters} />
			</div>
		</>
	)
}

export default BoliBooking
